// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1tquc","title":"AfterFrontImage_title__1CDzW"};